import { fetchPCStoreRankDetailsCountriesRanks } from '@/pages/intelligence/services/storeRank';

import type { IDateTypely, IRegionValue } from '@/pages/intelligence/types/common';
import type { IStoreRankDetailsCountriesRanks } from '@/pages/intelligence/types/storeRank';

export const fetchPCStoreRankDetailsCountriesRanksPlus = async (params: {
  edition_id: string;
  source: string[];
  regions: IRegionValue;
  granularity: IDateTypely;
  end_date: string;
}) => {
  const result: IStoreRankDetailsCountriesRanks[] = [];
  try {
    const res = await fetchPCStoreRankDetailsCountriesRanks({
      region_type: 'market',
      ...params,
    });
    const list = res?.data ?? [];
    for (const item of list) {
      const market = item?.market ?? '';
      const marketName = item?.name ?? '';
      const marketRank = item?.rank ?? Number.NaN;
      const countryRank: IStoreRankDetailsCountriesRanks = {
        countryCode: market,
        countryName: marketName,
        ranks: [
          {
            rankCode: 'rank',
            rankName: '',
            rankValue: marketRank,
          },
        ],
      };
      result.push(countryRank);
    }
  } catch (exception) {
    console.warn(exception);
  }
  return result;
};
